/* Purchase requests remain owned by the theme's native product-form.
 * The sticky control delegates to that same button; it never clears or replaces the cart. */
if (!customElements.get('ampm-creatine-stockup')) {
  customElements.define('ampm-creatine-stockup', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.querySelector('[data-offer-gallery]');
      this.offerImage = this.querySelector('[data-offer-image]');
      this.photoClick = event => {
        const control = event.target.closest('[data-offer-media]');
        if (!control || !this.gallery?.contains(control) || !this.offerImage) return;
        this.offerImage.removeAttribute('srcset');
        this.offerImage.src = control.dataset.src;
        this.offerImage.alt = control.dataset.alt;
        this.querySelector('[data-offer-caption]').textContent = control.dataset.caption;
        this.gallery.querySelectorAll('[data-offer-media]').forEach(button => {
          button.setAttribute('aria-pressed', String(button === control));
        });
      };
      if (this.gallery && this.offerImage) {
        this.gallery.hidden = false;
        this.gallery.addEventListener('click', this.photoClick);
      }
      this.mainButton = this.querySelector('[data-stockup-add]');
      this.sticky = this.querySelector('[data-stockup-sticky]');
      this.stickyButton = this.querySelector('[data-stockup-sticky-add]');
      if (!this.mainButton || !this.sticky || !this.stickyButton) return;
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      this.add = () => {
        if (!this.mainButton.disabled && this.mainButton.getAttribute('aria-disabled') !== 'true') this.mainButton.click();
      };
      this.stickyButton.addEventListener('click', this.add);
      this.buttonObserver = new MutationObserver(this.schedule);
      this.buttonObserver.observe(this.mainButton, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'] });
      this.overlayObserver = new MutationObserver(this.schedule);
      this.overlayObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule);
      window.addEventListener('pageshow', this.schedule);
      this.update();
    }
    disconnectedCallback() {
      this.gallery?.removeEventListener('click', this.photoClick);
      cancelAnimationFrame(this.frame);
      this.buttonObserver?.disconnect();
      this.overlayObserver?.disconnect();
      this.stickyButton?.removeEventListener('click', this.add);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      window.removeEventListener('pageshow', this.schedule);
    }
    update() {
      if (!this.mainButton || !this.sticky || !this.stickyButton) return;
      const busy = this.mainButton.classList.contains('loading') || this.mainButton.getAttribute('aria-disabled') === 'true';
      this.stickyButton.disabled = this.mainButton.disabled || busy;
      this.stickyButton.textContent = busy ? 'Adding…' : this.mainButton.disabled ? 'Sold out' : this.mainButton.dataset.stickyLabel || 'Add pack';
      const footer = document.querySelector('.wt-footer')?.getBoundingClientRect();
      const overlay = document.body.classList.contains('page-overlay-cart-on') || document.body.classList.contains('overflow-hidden') || !!document.querySelector('dialog[open], cart-drawer.active, cart-drawer[open], .wt-cart__drawer--open');
      this.sticky.hidden = this.mainButton.getBoundingClientRect().bottom > 0 || overlay || !!(footer && footer.top < window.innerHeight);
    }
  });
}
